// eslint-disable-next-line import/prefer-default-export
import api from "@/api/api";
// import backlog from "@/api/backlog";

export const authActions = {
    async login(context, { email, password }) {
        try {
            // await backlog.login(email, password);
            await api.login(email, password).then(res => {
                context.commit('AUTHENTICATED', res.data)
                api.setToken(`${res.data.token_type} ${res.data.access_token}`)
                context.dispatch('getLangCode')
                context.dispatch('getConstants').then(() => location.assign('/'))
            })
        }
        catch (err) {
            if (err.response) {
                context.commit('SET_LOGIN_ERROR', err.response.data.errorCode)
            }
        }
    },

    logout(context) {
        // backlog.logout();
        context.commit('LOGOUT');
    },

    checkToken(context) {
        var now = Date.now()
        var expiresAt = parseInt(localStorage.getItem('expires_at'))
        if (now > expiresAt) {
            context.dispatch('logout')
        }
    }
};
